import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";

import ToolPage from '../partials/ToolPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import NoLabelTemplatesBox from '../partials/NoLabelTemplatesBox';
import WroPrintLine from "./WroPrintLine";
import ModifyCountDialog from './ModifyCountDialog';

import { Button, Text, H4, H3, H2, Dropdown, Panel } from '@bigcommerce/big-design';
import { ArrowDropDownIcon, FileDownloadIcon } from '@bigcommerce/big-design-icons';

import { findWarehouseReceiveingOrder } from '../../redux/actions/warehouseReceivingOrders';
import { indexBarcodeTemplates } from '../../redux/actions/barcodeTemplates';
import { requestPrint } from '../../redux/actions/prints';
import { locationsIndex } from '../../redux/actions/locations';

const PrintWro = ({ payload, loadWro, warehouseReceivingOrders, barcodeTemplates, prints, downloadUrl, getTemplates, postPrint, settings, locations, loadLocations }) => {
  let { wroId } = useParams();

  const [submitted, setSubmitted] = useState(false);
  const [activeTemplate, setActiveTemplate] = useState({});
  const [modifyItem, setModifyItem] = useState(null);
  const [modifyType, setModifyType] = useState(null);
  const [modifyCount, setModifyCount] = useState(null);
  const [modifyItemId, setModifyItemId] = useState(null);
  const [showPrintCountDialog, setShowPrintCountDialog] = useState(false);
  const [labelCount, setLabelCount] = useState(0);
  const [activeLocation, setActiveLocation] = useState(null);

  const [printCounts, setPrintCounts] = useState({
      products: {},
      variations: {}
    }
  )

  const [sortOrder, setSortOrder] = useState('SKU');

  const switchActiveTemplate = (event) => {
    let template = barcodeTemplates.templates.find(template => template.uuid === event.hash);
    setActiveTemplate(template);
  }

  const templates = () => {
    let templateItems = [];

    barcodeTemplates.templates.map(template => 
      templateItems.push(
        {
          content: template.template_name,
          onItemClick: (event) => switchActiveTemplate(event),
          hash: template.uuid
        }
      )
    )

    return templateItems;
  }

  const setPrintCount = (type, itemId, modifyItem, count) => {
    let tempCounts = printCounts;

    tempCounts[type][itemId] = {
      count: count,
      item: modifyItem
    };

    setPrintCounts(tempCounts);
    calculateTotal();
  }

  const calculateTotal = () => {
    let tempTotal = 0;

    Object.keys(printCounts.products).map(itemId =>
      tempTotal = tempTotal + (parseInt(printCounts.products[itemId]?.count) || 0)
    )

    Object.keys(printCounts.variations).map(itemId =>
      tempTotal = tempTotal + (parseInt(printCounts.variations[itemId]?.count) || 0)
    )

    setLabelCount(tempTotal);
  }

  const sortItems = () => {
    let items = [];

    items.push(
      {
        content: 'SKU',
        onItemClick: () => setSortOrder('SKU'),
        hash: 'SKU'
      }
    );

    items.push(
      {
        content: 'Bin Picking Number (Default location)',
        onItemClick: () => setSortOrder('Bin Picking Number (Default location)'),
        hash: 'Bin Picking Number (Default location)'
      }
    );

    items.push(
      {
        content: 'Name',
        onItemClick: () => setSortOrder('Name'),
        hash: 'Name'
      }
    );



    return items;
  }

  const switchLocation = (event, setter) => {
    let location = locations.locations.find(location => location.id === event.hash);
    setter(location);
  }

  const locationItems = () => {
    let items = [];

    locations.locations.map(location => 
      items.push(
        {
          content: location.label,
          onItemClick: (event) => switchLocation(event, setActiveLocation),
          hash: location.id
        }
      )
    )

    return items;
  }

  const download = () => {
    postPrint(payload, activeTemplate.uuid, printCounts, sortOrder, activeLocation?.id);
    setSubmitted(true);
  }

  useEffect(() => {
    loadWro(payload, wroId);
    getTemplates(payload);

    if(settings.settings.enable_custom_fields) {
      loadLocations(payload);
    }

  }, []);

  useEffect(() => {
    calculateTotal();
  }, [printCounts]);

  useEffect(() => {
    if (warehouseReceivingOrders.activeWro) {
      let tempCounts = {
        products: {},
        variations: {}
      };

      let item = {};
      let wro_line = {};
      let packQuantity = 1;

      warehouseReceivingOrders.variants?.data?.forEach((variant) => {
        warehouseReceivingOrders.activeWro.warehouse_receiving_order_lines.forEach((line) => {
          if(line.purchase_order_line.variant_id === variant.id) {
            wro_line = line;
          }
        });

        packQuantity = 1;

        if(wro_line.pack_quantity) {
          packQuantity = parseInt(wro_line.pack_quantity);
        }

        item = {
          binPickingNumber: variant.bin_picking_number,
          brand: variant.brand_name,
          hasBarcode: warehouseReceivingOrders.activeWro.variants_with_barcodes.includes(variant.id),
          imageUrl: wro_line.purchase_order_line.source_image_url,
          name: wro_line.purchase_order_line.source_name,
          options: variant.option_values,
          price: variant.calculated_price,
          quantity: variant.inventory_level,
          sku: variant.sku,
          upc: variant.upc,
          mpn: variant.mpn
        };

        tempCounts.variations[variant.id] = {
          count: wro_line.count * packQuantity,
          item: item
        }
      });

      warehouseReceivingOrders.products?.data?.forEach((product) => {
        warehouseReceivingOrders.activeWro.warehouse_receiving_order_lines.forEach((line) => {
          if((line.purchase_order_line.variant_id === null) && (line.purchase_order_line.product_id === product.id)) {
            wro_line = line;
          }
        });

        packQuantity = 1;

        if(wro_line.pack_quantity) {
          packQuantity = parseInt(wro_line.pack_quantity);
        }

        item = {
          binPickingNumber: product.bin_picking_number,
          brand: product.brand_name,
          hasBarcode: warehouseReceivingOrders.activeWro.products_with_barcodes.includes(product.id),
          imageUrl: wro_line.purchase_order_line.source_image_url,
          name: wro_line.purchase_order_line.source_name,
          options: product.option_values,
          price: product.calculated_price,
          quantity: product.inventory_level,
          sku: product.sku,
          upc: product.upc,
          mpn: product.mpn
        };

        tempCounts.products[product.id] = {
          count: wro_line.count * packQuantity,
          item: item
        }
      });

      setPrintCounts(tempCounts);
    }
  }, [warehouseReceivingOrders])

  useEffect(() => {
    if(downloadUrl && submitted) { 
      let win = window.open(downloadUrl, '_blank');
      win.focus();
      setSubmitted(false);
    }
  }, [downloadUrl]);

  useEffect(() => {
    if (barcodeTemplates.status === 'success' && barcodeTemplates.templates.length > 0 && !activeTemplate.uuid) {      
      setActiveTemplate(barcodeTemplates.templates[0]);
    }
  }, [barcodeTemplates]);

  const description = () => {
    return(
      <> 
        <Text>Print a Warehouse Receiving Orders from the Supplier Purchase Orders app.</Text>
        <Text>Select a label print template to download a print file for this warehouse receiving order. The number of each label to be printed should be set by the warehouse receiving order, but you can still update them to another number if you want to by clicking on the item you want to update in the list below.</Text>
        <Text>Click the "Confirm and Download Print File" button to download a print pdf.</Text>
      </>
    )
  }

  return(
    <>
      <ToolPage title="Print Warehouse Receiving Order" description={description()} helpLink="bigcommerce/print-warehouse-receiving-order-labels/">

        <Panel>
          <H2>Print Template</H2>
          { barcodeTemplates.status === 'success' && barcodeTemplates.templates.length > 0 && 
            <Dropdown
              items={templates()}
              maxHeight={250}
              placement="bottom-start"
              toggle={<Button iconRight={<ArrowDropDownIcon />}>{activeTemplate?.template_name || "Select Template"}</Button>}
            />
          }
          { barcodeTemplates.status === 'success' && barcodeTemplates.templates.length === 0 && 
            <NoLabelTemplatesBox/>
          }

          { barcodeTemplates.status !== 'success' &&
            <LoadingSpinner size="xxSmall" statusText="Loading Templates" />
          }
          { activeTemplate?.uuid && (labelCount > 0) && (prints.status !== "requesting") && 
            <div className="top-15">
              <Button iconRight={<FileDownloadIcon />} onClick={() => download()}>
                Confirm and Download Print File
              </Button>
              <Text color="warning40">
                Please ensure your browser allows popups for this page when downloading your print file.
              </Text>
            </div> }
          { (!activeTemplate.uuid || (labelCount === 0)) && (prints.status !== "requesting") && <div className="top-15"><Button iconRight={ <FileDownloadIcon /> } disabled>Confirm and Download Print File</Button></div> }
          { prints.status === "requesting" && 
            <div className="top-15">
              <LoadingSpinner size="xxSmall" statusText="Generating Print File" />
              <Text color="warning40">
                Please ensure your browser allows popups for this page when downloading your print file.
              </Text>
            </div>
          }
          <hr/>

          <H3>Print Settings</H3>

          <div className="background-darken padding-20 flex-container">
            <div className="flex-1">
              <H4>Sort Order</H4>
              <Dropdown
                items={sortItems()}
                maxHeight={250}
                placement="bottom-start"
                toggle={<Button iconRight={<ArrowDropDownIcon />}>{sortOrder}</Button>}
              />
            </div>

            <div className="flex-1">
              { settings.settings.enable_bpn_location &&
                <>
                  { locations.status !== 'success' &&
                    <LoadingSpinner size="xxSmall" statusText="Loading Locations" />
                  }

                  { locations.status === 'success' &&
                    <Dropdown
                      items={locationItems()}
                      maxHeight={250}
                      placement="bottom-start"
                      toggle={<Button iconRight={<ArrowDropDownIcon />}>{activeLocation?.label || "Select Location"}</Button>}
                    />
                  }
                </>
              }
            </div>
          </div>
        </Panel>

        { !warehouseReceivingOrders.activeWro &&
          <Panel>
            <LoadingSpinner statusText="Loading Warhouse Receiving Order" />
          </Panel>  
        }


        { warehouseReceivingOrders.activeWro &&
          <Panel>

          { Object.keys(printCounts.products).map(itemId =>
              <WroPrintLine
                id={itemId}
                itemId={itemId}
                item={printCounts.products[itemId].item}
                type='products'
                printCount={printCounts.products[itemId]?.count}
                setModifyItem={setModifyItem}
                setModifyType={setModifyType}
                setModifyCount={setModifyCount}
                setModifyItemId={setModifyItemId}
                setShowPrintCountDialog={setShowPrintCountDialog}
                missingBarcode={ !(warehouseReceivingOrders.activeWro.products_with_barcodes.includes(parseInt(itemId)))  }
              />
            )
          }

          { Object.keys(printCounts.variations).map(itemId =>
              <WroPrintLine
                id={itemId}
                itemId={itemId}
                item={printCounts.variations[itemId].item}
                type='variations'
                printCount={printCounts.variations[itemId]?.count}
                setModifyItem={setModifyItem}
                setModifyType={setModifyType}
                setModifyCount={setModifyCount}
                setModifyItemId={setModifyItemId}
                setShowPrintCountDialog={setShowPrintCountDialog}
                missingBarcode={ !(warehouseReceivingOrders.activeWro.variants_with_barcodes.includes(parseInt(itemId))) }
              />
            )
          }

          </Panel>
        }


        { showPrintCountDialog &&
          <ModifyCountDialog
            modifyItemId={modifyItemId}
            modifyItem={modifyItem}
            modifyType={modifyType}
            modifyCount={modifyCount}
            setPrintCount={setPrintCount}
            setShowPrintCountDialog={setShowPrintCountDialog}
            showPrintCountDialog={showPrintCountDialog}
          />
        }
          
      </ToolPage>
    </>
  ) 


}

const mapStateToProps = state => ({
  warehouseReceivingOrders: state.warehouseReceivingOrders,
  barcodeTemplates: state.barcodeTemplates,
  prints: state.prints,
  downloadUrl: state.prints.downloadUrl,
  settings: state.settings,
  locations: state.locations,
});

const mapDispatchToProps = (dispatch) => ({
  loadWro: (payload, id) => dispatch(findWarehouseReceiveingOrder(payload, id)),
  getTemplates: (payload) => dispatch(indexBarcodeTemplates(payload)),
  postPrint: (payload, template, printCounts, sortOrder, locationId) => dispatch(requestPrint(payload, template, printCounts, sortOrder, null, locationId)),
  loadLocations: (payload) => dispatch(locationsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrintWro);